import { alpha } from "@mui/material"

export const softPrimary =
  (opacity = 0.08) =>
  (theme) =>
    alpha(theme.palette.primary.main, opacity)

export const softWarning =
  (opacity = 0.12) =>
  (theme) =>
    alpha(theme.palette.warning.main, opacity)

const schemeTokens = {
  radius: {
    card: "12px",
    control: "8px",
    tile: "8px",
    pill: "9999px",
  },
  color: {
    brand: "primary.main",
    brandSoft: "primary.light",
    border: "grey.200",
    trackBg: "grey.100",
    stripBg: "grey.50",
    surface: "common.white",
    label: "grey.500",
    muted: "text.secondary",
    positive: "success.main",
    noteText: "warning.dark",
  },
  text: {
    eyebrow: {
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: ".08em",
      textTransform: "uppercase",
    },
    pageTitle: { fontSize: 22, fontWeight: 700, letterSpacing: "-.01em" },
    sectionTitle: { fontSize: 16, fontWeight: 700 },
    cardTitle: { fontSize: 16, fontWeight: 700 },
    statLabel: { fontSize: 11, color: "grey.600" },
    schemeId: {
      fontSize: 10.5,
      fontWeight: 700,
      letterSpacing: ".04em",
      textTransform: "none",
    },
    statValue: { fontSize: 14, fontWeight: 700 },
    body: { fontSize: 13, lineHeight: 1.55 },
    hint: { fontSize: 11.5, color: "text.secondary" },
    amount: { fontSize: 20, fontWeight: 800, lineHeight: 1.15 },
  },
}

export default schemeTokens
